import React from 'react'
import { useTranslation } from 'react-i18next'

function Hero() {
  const { t } = useTranslation()

  return (
    <section className="section hero" aria-labelledby="hero-tagline">
      <div className="container-wide hero-grid">
        <div className="hero-text">
          <p id="hero-tagline" className="hero-tagline">{t('hero.tagline')}</p>

          <a
            href="#reviews"
            className="hero-rating"
            aria-label={`${t('hero.ratingStars')} - ${t('hero.ratingCount')}`}
          >
            <span className="hero-rating-prefix">{t('hero.ratingPrefix')}</span>
            <span className="hero-rating-stars" aria-hidden="true">{t('hero.ratingStars')}</span>
            <span className="hero-rating-count">{t('hero.ratingCount')}</span>
          </a>

          <div className="hero-cta-row">
            <a href="tel:+14694917604" className="btn-primary">
              {t('hero.callCta')}
            </a>
            <a href="#location" className="btn-secondary">
              {t('hero.findCta')}
            </a>
          </div>
        </div>

        <div className="hero-logo-wrap">
          <img
            src="/images/logo.jpg"
            alt={t('hero.logoAlt')}
            className="hero-logo"
            width="600"
            height="700"
          />
        </div>
      </div>
    </section>
  )
}

export default Hero
